import React from 'react';
import { PriceType } from '@api/generated/search-service';
import PriceTypeCodeTag from '@features/pricetypes/PriceTypeCodeTag.tsx';
import { PriceTypeCode, resolvePriceTypeCode } from '@features/pricetypes/priceTypeCodes';
import { SizeVariant } from '@utils/types.ts';

interface ComponentProps {
  /** Kód ze serveru; když chybí, odvodí se z priceType/isGaranted/isCustomProduct. */
  priceTypeCode?: PriceTypeCode | string | null;
  priceType?: PriceType | string | null;
  isGaranted?: boolean;
  isCustomProduct?: boolean;
  variant?: 'full' | 'short';
  size?: SizeVariant;
}

/** Jediné místo, kde se v UI rozhoduje, jak se typ ceny zobrazí. */
const PriceTypeComponent: React.FC<ComponentProps> = ({ priceTypeCode, priceType, isGaranted, isCustomProduct, variant, size }) => {
  const code = (priceTypeCode as PriceTypeCode) ?? resolvePriceTypeCode(priceType, isGaranted, isCustomProduct);
  if (!code) return null;

  return <PriceTypeCodeTag code={code} variant={variant} size={size} />;
};

export default PriceTypeComponent;
